import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { toast } from "@hubertai/hubert-component-library";
import { fetchInvitation, sendBenefitsEmail } from "../../behavior/api/invitation";
import Header from "../../components/header/Header";
import CompletedAlert from "../../components/interview/CompletedAlert";
import { ApplicationLanguage, PageState } from "../../constants";
import type { Invitation } from "../../types/invitation";
import InviteEmailSignUp from "../registration/InviteEmailSignUp";
import "./InterviewCompletedPageInviteEmail.css";

const InterviewCompletedPageInviteEmail = () => {
    const { t, i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [invitation, setInvitation] = useState<Invitation>();

    const verify = useCallback(
        async (token: string): Promise<void> => {
            try {
                const invitationData = await fetchInvitation(token);

                if (!invitationData) {
                    toast.error(t("AppMessages.server-error"));
                    return;
                }

                const type = invitationData.__typename ?? invitationData.type;
                if (type !== "Invitation") {
                    toast.error(t(`ProcessInvitation.${type}`));
                    navigate("/", { replace: true });
                    return;
                }

                if (invitationData.interviewCompleted) {
                    await sendBenefitsEmail({
                        token,
                        language: (i18n && i18n.language) ?? ApplicationLanguage.EN_EU,
                    });
                    setInvitation(invitationData);
                } else {
                    toast.error(t("InterviewCompletedPageInviteEmail.InterviewNotCompleted"));
                    navigate("/", { replace: true });
                }
            } catch (e) {
                toast.error(t((e as Error).message));
            }
        },
        [navigate, t, i18n],
    );

    useEffect(() => {
        const token = searchParams.get("token");
        if (token) {
            verify(token);
        }
    }, [searchParams, verify]);

    return (
        <>
            <Header />
            <div className="interview-completed-invite-email-wrapper">
                <CompletedAlert />
                <InviteEmailSignUp interviewCompleted invitation={invitation} state={PageState.INTERVIEW_COMPLETED} />
            </div>
        </>
    );
};

export default InterviewCompletedPageInviteEmail;
